//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div class='component-wrapper'>
    <div class="top-menu-icon" @click="changeShowMode()" @mouseover="leaving = false">
      <Icon type="navicon"></Icon>
    </div>

    <div :class="[showMode == true ? 'top-menu-panel' : 'hidden-menu']" @mouseover="leaving = false" @mouseleave="tryToLeave()">

      <div v-if="activeUser != null" class="top-menu-user top-menu-link" @click="$router.push('/profile')">
        <div style="width:100%; padding-left:50px; float:left"><div class="top-menu-user-avatar" :style="{'background-image': 'url(' + serverData.imagesGetURL(activeUser.body.avatar) + ')'}">&nbsp;</div></div>
        <div style="width:100%; margin-top:10px; text-align:center; float:left">{{activeUser.name}}</div>
      </div>
      <div v-else class="top-menu-user" style="padding-top:30px">ВХОД В АККАУНТ</div>

      <div class="top-menu-line" style="margin:20px 0 10px 0">&nbsp;</div>

      <div class="top-menu-item" v-if="activeUser == null" @click="showMode = false; loginOnClick()">
        <i class="fas fa-user-circle top-menu-item-icon" style="padding-right:1px;"></i>
        Вход
      </div>

      <div class="top-menu-item" @click="showMode = false">
        <i class="fas fa-fire top-menu-item-icon"></i>
        <router-link to="/">Лента событий</router-link>
      </div>
      <div class="top-menu-item" @click="showMode = false; copyInvitationLinkToClipboardOnClick()">
        <i class="fas fa-share-alt top-menu-item-icon"></i>
        Пригласить друга
      </div>
      <div class="top-menu-item" v-if="activeUser != null" @click="showMode = false">
        <i class="fas fa-plus-circle top-menu-item-icon"></i>
        <router-link to="/event-edit">Создать событие</router-link>
      </div>
      <div class="top-menu-item" @click="showMode = false">
        <!--i class="fas fa-basketball-ball top-menu-item-icon"></i-->
        <i class="fas fa-map-marker-alt top-menu-item-icon"></i>
        <router-link to="/places">Места в городе</router-link>
      </div>
      <div class="top-menu-item" v-if="activeUser != null" @click="showMode = false">
        <i class="fas fa-user top-menu-item-icon"></i>
        <router-link to="/profile">Профиль</router-link>
      </div>
      <div class="top-menu-item" v-if="activeUser != null" @click="showMode = false; logoutOnClick()">
        <i class="fas fa-power-off top-menu-item-icon" style="font-size:18px; padding-right:1px;"></i>
        Выход
      </div>

      <div class="top-menu-line" style="margin:5px 0 0 0">&nbsp;</div>
      <div class="top-menu-text" style="text-align:center;">
        &copy; ВСЕЗДЕСЬ, 2022
        <br>
        {{appSettings.appVer}}
      </div>

    </div>

  </div>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters, mapMutations } from 'vuex'

import http from 'axios'
import serverErrorHandling from '@/technical/serverErrorHandling'

import serverData from '@/store/serverData'

export default {
  data () {
    return {
      showMode: false,
      leaving: false,

      serverData: serverData // to make access from UI template
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'activeUser',
      'commonData'
    ])
  },
  methods: {
    changeShowMode () {
      this.showMode = !this.showMode
    },
    tryToLeave () {
      var thisRef = this
      // setTimeout(function () {
      thisRef.leaving = true
      // }, 1)
      setTimeout(function () {
        if (thisRef.leaving === true) thisRef.showMode = false
      }, 1000)
    },
    copyInvitationLinkToClipboardOnClick () {
      var thisRef = this
      var link = window.location.href
      if (this.activeUser != null) link += '?inv=' + this.activeUser.id
      navigator.clipboard.writeText(link).then(function () {
        thisRef.$message.info('Ссылка для приглашения друга скопирована в буфер обмена')
      }, function (err) {
        thisRef.$message.error('Ошибка при попытке скопировать ссылку в буфер обмена:' + err)
      })
    },
    loginOnClick () {
      localStorage.setItem('lastLandPage', window.location.pathname) // url страницы без протокола http хоста и порта. при рутовской странице pathname='/'
      this.$router.push('/welcome')
    },
    logoutOnClick () {
      var thisRef = this

      // !!! здесь надо чтобы даже если нет связи с сервером сессия не восстановилась. а сейчас это не так
      thisRef.activeUserSet(null)
      // localStorage.removeItem('BMSClient2017ActiveUser')

      http.get(this.appSettings.server.userLogout)
      .then(function (response) {
        // делаем переход только после того как на сервере произошел logout и при открытии страницы getActiveUser уже возвращал 403
        // здесь не через vuejs router чтобы страница какбы обновилась и все сомпоненты приложения vuejs обнулились. иначе после перелогина открытые ранее страниы сохраняют старые значения
        window.location.href = '/'
        // !!! ранее удаление из localStorage было тут. но если сервер недоступен (отвалился) то разлогинится вообще не получится. а тут хотя бы в браузере
        // !!! тогда что тут?
      })
      .catch(function (error) {
        if (error.response) {
          serverErrorHandling(error, thisRef)
        } else {
          serverErrorHandling(error, thisRef)
          thisRef.appStateServerConnectedSet(false)
          thisRef.$router.push('/serverisnotavailable')
        }
      })
    },
    ...mapMutations([
      'activeUserSet'
    ])
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.component-wrapper{
  margin: 0px 0px 0px 0px;
  padding: 0px;
}
.top-menu-icon {
  z-index: 99999;
  position: fixed;
  top: 8px;
  right: 12px;
  padding: 0px 7px 0 7px;
  color: #606068;
  font-size: 32px;
}
.top-menu-icon:hover {
  color: #808088;
}
.hidden-menu {
  z-index: 99998;
  position: fixed;
  top: 0px; /* topmenulane - 50px*/
  width: 266px;
  height: calc(100vh - 0px); /* topmenulane - 50px*/
  margin: 0px;
  padding: 20px 0px 20px 0px;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 8px 0 0 8px;
  opacity: 0 !important;
  left: 100vw !important;
  transition: all .1s ease-out;
}
.top-menu-panel {
  z-index: 99998;
  position: fixed;
  top: 	0px;  /* topmenulane - 50px*/
  left: calc(100vw - 265px);
  width: 266px;
  height: calc(100vh - 0px); /* topmenulane - 50px*/
  margin: 0px;
  padding: 20px 0px 20px 0px;
  background: #333333;
  border: 1px solid #333333;
  border-radius: 8px 0 0 8px;
  opacity: 1;
  transition: all .1s ease-out;
}
.top-menu-item-icon {
  font-size: 18px;
  padding-right: 2px;
  color: #c0c0c8;
}
.top-menu-item {
  width: 100%;
  height: 42px;
  padding: 7px 30px 0 30px;
  color: #b0b0b8;
  font-family: "Open Sans", sans-serif;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 1px;
  cursor: default;
  float: left;
}
.top-menu-item a {
  color: #b0b0b8;
}
.top-menu-item a:visited {
  color: #b0b0b8;
  text-decoration: none !important;
}
.top-menu-item:hover {
  color: #d0d0d8;
}
.top-menu-item a:hover {
  color: #d0d0d8 !important;
  cursor: default;
  text-decoration: none !important;
}
.top-menu-line {
  width: 100%;
  height: 3px;
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 0 0px;
  color: #fff;
  font-size: 1px;
  border-top: 1px solid #4b4b4b;
  float: left;
}
.top-menu-text {
  width: 100%;
  padding: 7px 30px 0 30px;
  color: #707078;
  font-family: "Open Sans", sans-serif;
  font-weight: 500;
  font-size: 11px;
  float: left;
}
.top-menu-user {
  width: 100%;
  padding: 7px 30px 0 30px;
  color: #d0d0d8;
  font-family: "Open Sans", sans-serif;
  font-weight: 500;
  font-size: 15px;
  float: left;
}
.top-menu-user-avatar {
  width: 100px;
  height: 100px;
  background: #202020;
  background-size: cover;
  background-position: center;
  border-radius: 50px;
  border: solid 0px #fff;
  float: left;
}
.top-menu-link {
  cursor:pointer;
}
.top-menu-link:hover {
  color: #e8e8ef;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// TopMenu.vue?cd33d3b2